// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".input-color {\n  -webkit-appearance: none;\n  -moz-appearance: none;\n  appearance: none;\n  width: 100px;\n  height: 48px;\n  background-color: transparent;\n  border: none;\n  cursor: pointer;\n  padding: 0;\n}\n.input-color::-webkit-color-swatch {\n  border-radius: 5px;\n  box-shadow: inset 0 0 1px 0 rgba(0, 0, 0, 0.3);\n}\n.input-color::-moz-color-swatch {\n  border-radius: 5px;\n  box-shadow: inset 0 0 1px 0 rgba(0, 0, 0, 0.3);\n}\n", ""]);
// Exports
module.exports = exports;
